import { FC, PropsWithChildren } from 'react';
import { ClientAppSettingsResponse } from '../../../api/dtos/dtos';
import AppSettingsContext from '../../../contexts/data/AppSettingsContext';
import useGetClientAppSettings from '../../../hooks/data/useGetClientAppSettings';
import Loader from '../../common/Loader';
import { Box } from '@mui/material';

export interface IAppSettingsProviderProps {
    initial?: ClientAppSettingsResponse | null;
}

export const AppSettingsProvider: FC<PropsWithChildren<IAppSettingsProviderProps>> = ({ initial, children }) => {
    const appSettings = useGetClientAppSettings({ fallbackData: initial});

    if (appSettings.loading) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    width: '100%',
                    height: '95vh',
                    overflow: 'hidden'
                }}
            >
                <Loader />
            </Box>  
        );
    }

    return (
        <AppSettingsContext.Provider value={appSettings}>
            {children}
        </AppSettingsContext.Provider>
    );
}

export default AppSettingsProvider;

